import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ApiFailure } from './api';
import './index.css';
import { App } from './App';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 4xx answers are final (no session, not found, forbidden); retry only network and 5xx failures.
      retry: (n, e) => n < 2 && !(e instanceof ApiFailure && e.status >= 400 && e.status < 500),
      refetchOnWindowFocus: true,
      staleTime: 30_000,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
